module.exports = __webpack_public_path__ + "img/graphic3.46223a38.svg";